import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Upload, Modal } from 'antd';
import {
  PlusOutlined, LoadingOutlined,
} from '@ant-design/icons';
import AttachmentActions from '@Actions/attachmentActions';
import Constants from '@Apis/constants';
import './style.scss';

const { confirm } = Modal;

const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

class Attachment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      loading: false,
    };
  }

  componentDidMount() {
    const { fileList } = this.props;
    this.setState({ fileList });
  }

  componentWillUnmount() {
    const {
      getAttachmentByIdSuccess,
    } = this.props;
    getAttachmentByIdSuccess(null);
  }

  handleFileChange(fileListData) {
    const {
      updateAttachment, entityId, entityName, getAttachmentById,
    } = this.props;

    const fileList = fileListData?.fileList?.map((item) => ({
      ...item,
      url: item?.response?.response?.location || item?.url,
    }));

    const attachments = fileList?.map((attachment) => ({
      url: attachment?.response?.response?.location || attachment?.url,
      type: attachment.type,
      name: attachment.name,
      uid: attachment.uid,
    }));

    if (fileListData?.file.status === 'done' || fileListData?.file.status === 'removed') {
      const payload = {
        entity_id: entityId,
        entity_name: entityName || 'purchase_order',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(entityId, 'purchase_order');
      });
    }
  }

  static defaultProps = {
    updateEnable: true,
  };

  render() {
    const {
      disableCase, containerClassName, labelClassName, handleFileChange,
      entityId, getAttachmentByIdLoading, label, updateEnable
    } = this.props;
    const { loading } = this.state;

    const rawFileList = entityId ? this.state.fileList : this.props.fileList;

    // Modify preview URLs for display only
    const fileList = rawFileList?.map(file => ({
      ...file,
      url: file?.url?.includes('procuzystorage.blob.core.windows.net')
        ? file.url.replace('https://procuzystorage.blob.core.windows.net/', Constants.CDN_URL)
        : file.url
    }));

    return (
      <React.Fragment>
        <div className={`${containerClassName || ''} attachment__wrapper `}>
          <label className={labelClassName || ''} style={{ marginBottom: '5px' }}>
            {label || 'Attachment(s)'}
          </label>
          <Upload
            action={Constants.UPLOAD_FILE}
            listType="picture-card"
            fileList={fileList}
            disabled={disableCase || loading || getAttachmentByIdLoading || !updateEnable}
            onChange={(value) => {
              if (value?.file?.status === 'done' || value?.file?.status === 'removed') {
                this.setState({ loading: false });
              } else {
                this.setState({ loading: true });
              }
              if (entityId) {
                this.handleFileChange(value);
              } else {
                handleFileChange(value);
              }
            }}
            onRemove={() => new Promise((resolve) => {
              confirm({
                title: 'Are you sure you want to Delete ?',
                onOk: () => resolve(true),
              });
            })}
            multiple
          >
            {fileList?.length >= 20
              ? null
              : (loading ? <LoadingOutlined style={{ fontSize: '35px' }} /> : uploadButton)}
          </Upload>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers, AttachmentReducers }) => ({
  user: UserReducers.user,
  getAttachmentByIdLoading: AttachmentReducers.getAttachmentByIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getAttachmentById: (entityId, entityName, callback) => dispatch(
    AttachmentActions.getAttachmentById(entityId, entityName, callback),
  ),
  updateAttachment: (payload, callback) => dispatch(
    AttachmentActions.updateAttachment(payload, callback),
  ),
  getAttachmentByIdSuccess: (selectedAttachment) =>
    dispatch(AttachmentActions.getAttachmentByIdSuccess(selectedAttachment)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Attachment));
